import { render, staticRenderFns } from "./standardAbnormalDisk.vue?vue&type=template&id=6140b47c&scoped=true"
import script from "./standardAbnormalDisk.vue?vue&type=script&lang=js"
export * from "./standardAbnormalDisk.vue?vue&type=script&lang=js"
import style0 from "./standardAbnormalDisk.vue?vue&type=style&index=0&id=6140b47c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140b47c",
  null
  
)

export default component.exports